import { cn } from "@/lib/utils"

/**
 * The mark (icon) half of the lockup, kept separate from the typeset
 * <ChoiceLogo> wordmark in choice-graphics-logo.tsx.
 *
 * The mark is pink on every surface (Peter, 2026-09-08). This replaces the
 * earlier two-variant rule from the design system's brand-logo preview (pink on
 * paper, sun on the dark chrome): one fill now, so the mark reads as the same object in
 * the header, the footer, and the favicon. The colour is a fixed brand fill,
 * not a theme token, so it does not follow the light/dark scope.
 */
export const CHOICE_MARK_FILL = "#EA146F"

export type ChoiceMarkProps = React.ComponentPropsWithoutRef<"svg">

export function ChoiceMark({ className, ...props }: ChoiceMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="74 624 202 132"
      aria-hidden="true"
      className={cn("h-[1em] w-auto", className)}
      {...props}
    >
      <g fill={CHOICE_MARK_FILL}>
        <ellipse cx="157.55" cy="673.35" rx="16.07" ry="18.78" />
        <path d="M78.87,632.4c0,2.26,1.84,4.1,4.1,4.1h74.58c46.36,0,44.23,56.64,21.44,70.06-19.55,11.51-14.64,32.36-9.55,41.81,1.15,2.13,3.79,2.93,5.93,1.79l84.95-37.26c1.92-1.03,2.78-3.3,2.05-5.36-1.84-5.17-4.16-14.92,1.44-21.1,21.61-23.85,3.73-58.14-19.38-58.14H82.97c-2.26,0-4.1,1.84-4.1,4.1h0Z" />
      </g>
    </svg>
  )
}
